import { render, staticRenderFns } from "./serviceItem.vue?vue&type=template&id=281f1aa4&scoped=true&"
import script from "./serviceItem.vue?vue&type=script&lang=js&"
export * from "./serviceItem.vue?vue&type=script&lang=js&"
import style0 from "./serviceItem.vue?vue&type=style&index=0&id=281f1aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281f1aa4",
  null
  
)

export default component.exports